<div class="bz-space--stack-m"></div>
<div class="proxy-object" *ngIf="proxyObj">
  <div class="proxy-object--isenable">
    <bzg-switch id="isEnable" class="bz-space--stack-s bz-space--inline-s" [(ngModel)]="proxyObj.isEnable"></bzg-switch>
    <label for="isEnable">{{'PROXY.ENABLE'|translate}}</label>
  </div>
  <div class="proxy-object--url bz-space--stack-s">
    <div class="proxy-object--url--host  bz-space--inline-s">
      <label for="url" class="font-weight-bold">{{'PROXY.HOST'|translate}}</label>
      <bzg-input [disabled]="!proxyObj.isEnable"  id="url" [(ngModel)]="proxyObj.url"></bzg-input>
    </div>
    <div class="proxy-object--url--port">
      <label for="port" class="font-weight-bold">{{'PROXY.PORT'|translate}}</label>
      <bzg-input [disabled]="!proxyObj.isEnable"  id="port" [(ngModel)]="proxyObj.port"></bzg-input>
    </div>
  </div>
  <div class="proxy-object--allowedips">
    <label  class="font-weight-bold">{{'PROXY.IGNOREPROXY'|translate}}</label>
    <bzg-textarea  [disabled]="!proxyObj.isEnable" [(ngModel)]="allowedIps" (ngModelChange)="onTextBoxChange($event)"></bzg-textarea>
    <p> {{'PROXY.ALLOWEDIPS'|translate}}</p>
  </div>
  <div class="proxy-object--isenable">
    <bzg-checkbox [disabled]="!proxyObj.isEnable" [(ngModel)]="proxyObj.useAuthentication"></bzg-checkbox>
    <label>{{'PROXY.AUTH'|translate}}</label>
  </div>

  <div *ngIf="proxyObj.useAuthentication" class="proxy-object--credentials bz-space--stack-s">
    <div class="proxy-object--credentials--username bz-space--inline-s">
      <label for="username" class="font-weight-bold">{{'PROXY.USERNAME'|translate}}</label>
      <bzg-input [disabled]="!proxyObj.isEnable || !proxyObj.useAuthentication"  id="username"
                 [(ngModel)]="proxyObj.username"></bzg-input>
    </div>

    <div class="proxy-object--credentials--password">
      <label for="password" class="font-weight-bold">{{'PROXY.PASSWORD'|translate}}</label>
      <bzg-password [disabled]="!proxyObj.isEnable || !proxyObj.useAuthentication" id="password"
                    [(ngModel)]="proxyObj.password"></bzg-password>

    </div>
  </div>
  <div *ngIf="!proxyObj.useAuthentication" class="bz-space--stack-s" style="height: 60px"></div>


</div>
